import React, { Component } from "react";
import { path } from "ramda";
import { Row, Col, Card , Tooltip } from "antd";
import styled, { withTheme, css } from "styled-components";
import { ThemeHelper } from "../../hoc/with/withThemeProvider";
import I18n, { fromSyntax } from "../../i18n";
import Metrics from "../../theme/Metrics";
import Color, { DataVisualizeKeys } from "../../theme/Colors";
import { isFunction } from "../../util";
import { SimpleText, SingleLine } from "../text/OText";
import { isAlive, ArrayUtil, ColorUtil } from "../../util/";
import EmptyModal from "../modal/EmptyModal";
const EmptyBar = styled.div`
    min-height:50px;
`;

const HorizontalBar = styled.div`
  border-radius: ${Metrics.progressBar.horizontalBar.borderRadius}px;
  height: ${Metrics.progressBar.horizontalBar.height}px;
  background: ${props => props.color};
  width: ${props => props.width*100}%;
`;

const TextInBar = styled.span`
  width: 48.4px;
  height: 21px;
  font-weight: ${Metrics.progressBar.textInProgressBar.fontWeight};
  line-height: ${Metrics.progressBar.textInProgressBar.lineHeight}px;
  color: ${Metrics.progressBar.textInProgressBar.color};
  margin-left: ${Metrics.progressBar.textInProgressBar.marginLeft}px;
`;
const TopicName = styled.span`
  font-size: ${Metrics.progressBar.TopicName.fontSize}px;
  text-align: ${Metrics.progressBar.TopicName.textAlign};
  color: ${Metrics.progressBar.TopicName.color};
`;

const Title = styled.p`
  font-size: ${Metrics.fontSize.header}px;
  font-weight: bold;
`;

const EmptyHorizontalBar = styled.div`
  height: ${Metrics.progressBar.horizontalBar.height}px;
`;
const TextInEmptyHorizontalBar = styled.span`
  color: ${Color.unimportantFontAlphaColor};

`;

const Box = props => {
	console.log(props);
	return <div style={{ marginBottom: 5 }}>
		<TopicName>{props.title}</TopicName>
		<Tooltip title={`${props.title} : ${props.value} (${(props.value / props.allValueTopic * 100).toFixed(2)}%)`}>
			{props.value != 0 ? <HorizontalBar color={props.color} width={props.value / props.allValueTopic}>
				<TextInBar>
					{(props.value / props.allValueTopic * 100).toFixed(2)}%
				</TextInBar>
			</HorizontalBar> : <EmptyHorizontalBar>
				<TextInEmptyHorizontalBar>No value</TextInEmptyHorizontalBar>
			</EmptyHorizontalBar>}
		</Tooltip>
	</div>;
};
class HorizontalBarGraph extends Component {
  state = {  }
  render() {
  	const { sort = true ,isLoadMore= true, showSize = 3, style = undefined, value, colorType = DataVisualizeKeys.Primary, theme, data = { Work: 35, Love: 30 } } = this.props;
  	const arrayTopic = Object.keys(data).map(Val => { return { topic : Val,value:data[Val] }; });
  	const objSorted = sort? arrayTopic.sort((a,b)=> b.value - a.value): arrayTopic;
  	const objSortedSlice = objSorted.slice(0, showSize);
  	const keyTopic = Object.keys(data);
  	const allValueTopic = ArrayUtil.isAliveArray(keyTopic) ?
  		objSorted.reduce((a,b) => a+b.value,0) : [];
  	const color = ColorUtil.getVisualizeColor(theme,colorType,0);
  	return <div>
  		<Title>{value.title}</Title>
  		<div>
  			{ArrayUtil.isAliveArray(keyTopic) ? objSortedSlice.map(
  				(Val, index) => (
  					<Box
  						key={index}
  						title={Val.topic}
  						value={Val.value}
  						allValueTopic={allValueTopic}
  						color={color}
  						elementStyle={style}
  					/>
  				)
  			) : <EmptyBar />}
  			{
  				isLoadMore? <div>
  					<div style={{ textAlign: "center",  marginTop: "20px"}}>
  						<a style={{ color: "#00c4b3" }} onClick={() => this.refs.modal.showModal()}>
  							{I18n.t("load_more")}
  						</a>
  					</div>
  					<EmptyModal ref="modal" title="Topic">
  						{ArrayUtil.isAliveArray(keyTopic) ? objSorted.map(
  							(Val, index) => (
  								<Box
  									key={index}
  									title={Val.topic}
  									value={Val.value}
  									allValueTopic={allValueTopic}
  									color={color}
  									elementStyle={this.props.style}
  								/>
  							)
  						) : <EmptyBar />}
  					</EmptyModal>
  				</div> : <div/>
  			}
  		</div>
  	</div>;
  }
}


export default withTheme(HorizontalBarGraph);


// WEBPACK FOOTER //
// ./src/components/chart/ProgressBar.js